if (!customElements.get('cart-gwp')) {
  class CartGwp extends HTMLElement {
    constructor() {
      super();

      this.gwpProductId = this.getAttribute('data-gwp-id');
      this.gwpEvent = this.getAttribute('data-gwp');
      this.gwpType = this.getAttribute('data-type');
      this.cartDrawer = this.closest('cart-drawer');
      this.gwpRemoved = sessionStorage.getItem('removeGwp');
      this.gwpSubsRemoved = sessionStorage.getItem('removeSubsGwp');
      this.gwpBanner = this.querySelector('.CartDrawer__GWPBanner');
      this.property = this.getAttribute('data-property');

      if (this.gwpProductId && this.gwpEvent && !this.gwpRemoved && this.gwpType === 'one-time') {
        this.gwpUpdate();
      } else if (this.gwpRemoved) {
        this.gwpBanner?.remove();
      }

      if (this.gwpProductId && this.gwpEvent && !this.gwpSubsRemoved && this.gwpType === 'subscription') {
        this.gwpUpdate();
      }
    }

    gwpUpdate() {
      this.cartDrawer.fetchCart(this.getUrl(), this.getConfig(), true)
    }

    getUrl() {
      let url = '';
      if (this.gwpEvent === 'add') {
        url = routes.cart_add_url;
      } else {
        url = routes.cart_change_url;
      }

      return url
    }

    getConfig() {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      let data = {
        sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      };
      if (this.gwpEvent === 'add') {
        data.items = [{
          quantity: 1,
          id: `${this.gwpProductId}`,
          properties: {
            [this.property]: 'true'
          }
        }]
      } else {
        let gwpKey = this.gwpProductId;
        if (this.gwpType === 'subscription' && this.cartDrawer.querySelector('[data-subs-gwp-key]')) {
          gwpKey = this.cartDrawer.querySelector('[data-subs-gwp-key]').getAttribute('data-subs-gwp-key');
        } else if (this.gwpType === 'one-time' && this.cartDrawer.querySelector('[data-gwp-key]')) {
          gwpKey = this.cartDrawer.querySelector('[data-gwp-key]').getAttribute('data-gwp-key');
        }
        data.id = gwpKey;
        data.quantity = 0;
      }
      config.body = JSON.stringify(data);

      return config
    }
  }

  customElements.define('cart-gwp', CartGwp);

}